import { faLocationCrosshairs } from "@fortawesome/pro-regular-svg-icons"
import { CoreButton } from "component/w24/component/CoreButton"
import { motion } from "framer-motion"
import { Localization } from "libs/localization/localization"
import { EVariables } from "libs/style/w24_styling"
import { useIsWide } from "libs/utils/logic/responsiveLogic"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  map: string
  url: string
  className?: string
}

export const MapDemo = (props: Props): JSX.Element => {
  const isWide = useIsWide()

  const anim = isWide
    ? {
        backgroundPositionY: ["0px", "-300px", "0px"],
        backgroundPositionX: ["unset", "unset", "unset"],
        backgroundSize: ["cover", "cover", "cover"],
      }
    : {
        backgroundPositionY: ["0px", "-100px", "0px"],
        backgroundPositionX: ["50$", "50$", "50$"],
        backgroundSize: ["600px", "600px", "600px"],
      }

  return (
    <a href={props.url} target="_blank" rel="noreferrer">
      <S_MapDemo
        className={props.className}
        $map={props.map}
        animate={anim}
        transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
      >
        <S_CoreButton
          title={Localization.TRY_ACTION}
          icon={faLocationCrosshairs}
        />
      </S_MapDemo>
    </a>
  )
}

const S_MapDemo = styled(motion.div)`
  display: flex;
  width: 100%;
  height: 201px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background-image: url(${(props: { $map: string }) => props.$map});
  background-repeat: no-repeat;
  border-radius: ${EVariables.Radius2};
  cursor: pointer;
  position: relative;
  @media only screen and (min-width: 1260px) {
    width: 1260px;
    height: 400px;
  }
`

const S_CoreButton = styled(CoreButton)`
  position: relative;
`
